import { DEPENDENTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { pickSection } from '@convenia/employee-organisms/SystemFields/helpers'

export const mapSystemFields = (data = []) => ({
  dependents: pickSection(data, DEPENDENTS_AREA.DEPENDENTS, 'systemFields') || {},
})

export const mapCustomFields = (data = []) => ({
  dependents: pickSection(data, DEPENDENTS_AREA.DEPENDENTS, 'customFields') || {},
})
